export const OAUTH_ERROR_MESSAGE_KEYS = {
  email_taken: "auth.oauthErrors.emailTaken",
  state_invalid: "auth.oauthErrors.stateInvalid",
  access_denied: "auth.oauthErrors.accessDenied",
  provider_error: "auth.oauthErrors.providerError",
  unknown: "auth.oauthErrors.unknown"
} as const

export const oauthErrorMessageKey = (reason: string | null): string =>
  OAUTH_ERROR_MESSAGE_KEYS[reason as keyof typeof OAUTH_ERROR_MESSAGE_KEYS] ??
  OAUTH_ERROR_MESSAGE_KEYS.unknown
